import { useAuth } from "@/contexts/AuthContext";
import { CYCLE_SCOPE_LABEL } from "@/utils/cycleScope";

interface CycleScopeBannerProps {
  className?: string;
}

/**
 * Rappel visuel du cloisonnement : quand le rôle de l'utilisateur est limité
 * à un cycle, cette bannière explique que seules les données de ce cycle sont
 * affichées. Ne s'affiche pas pour un rôle global.
 */
export default function CycleScopeBanner({ className = "" }: CycleScopeBannerProps) {
  const { cycleScope } = useAuth();

  if (cycleScope === "GLOBAL") return null;

  return (
    <div
      className={`flex flex-wrap items-center gap-2.5 rounded-lg border border-accent-200 bg-accent-50/70 px-4 py-3 ${className}`}
    >
      <span className="w-7 h-7 rounded-md bg-accent-100 text-accent-700 flex items-center justify-center shrink-0">
        <i className="ri-filter-3-line"></i>
      </span>
      <p className="text-xs text-foreground-700">
        Vue restreinte au cycle{" "}
        <span className="font-semibold text-foreground-900">{CYCLE_SCOPE_LABEL[cycleScope]}</span> — seules les
        données de ce cycle sont affichées.
      </p>
    </div>
  );
}